import { render, staticRenderFns } from "./BannerMapa.vue?vue&type=template&id=4b8df3b5&"
import script from "./BannerMapa.vue?vue&type=script&lang=js&"
export * from "./BannerMapa.vue?vue&type=script&lang=js&"
import style0 from "./BannerMapa.vue?vue&type=style&index=0&id=4b8df3b5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports